/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ShopifyFulfillmentStatusFilter {
  UNSHIPPED="UNSHIPPED",
SHIPPED="SHIPPED",
FULFILLED="FULFILLED",
PARTIAL="PARTIAL",
SCHEDULED="SCHEDULED",
ON_HOLD="ON_HOLD",
UNFULFILLED="UNFULFILLED",
REQUEST_DECLINED="REQUEST_DECLINED"
}

/**
* ShopifyFulfillmentStatusFilter
*/
export const ShopifyFulfillmentStatusFilterEnumType = types.enumeration("ShopifyFulfillmentStatusFilter", [
        "UNSHIPPED",
  "SHIPPED",
  "FULFILLED",
  "PARTIAL",
  "SCHEDULED",
  "ON_HOLD",
  "UNFULFILLED",
  "REQUEST_DECLINED",
      ])
